import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';

import OneVideo from '@/modules/module-oneVideo';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init about page');
        
        var self = this;
        self.$content = self.$el;
        self.$moduleA = self.$content.find('.about-module-a');
        self.$moduleE = self.$content.find('.about-module-e');

        self.$moduleA.length > 0 && _.each(self.$moduleA, (moduleA) => {
            self.moduleA($(moduleA));
        })

        self.$moduleE.length > 0 && _.each(self.$moduleE, (moduleE) => {
            self.moduleE($(moduleE));
        })

    },

    events: {
        
    },
    
    moduleA: function($module){
        const sectionId = $module.attr(`id`);
        const $videos = $module.find('.video-wrapper');

        $module.slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false
        });
        
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: true
        });
    },
    
    moduleE: function($module){
        const $blocks = $module.find('.blocks');

        $blocks.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 4,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.xlarge,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: ORW.responsiveSizes.large,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: ORW.responsiveSizes.medium,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});